import { setRandomFavicon } from "./src/utils/setRandomFavicon";

/**
 * Option B safety:
 * Ensure dynamic favicon changes do NOT remove the stable SSR favicons that Google crawls.
 * We do this by:
 * - calling your existing setRandomFavicon()
 * - then ensuring at least one generic <link rel="icon"> exists that can be swapped
 *   (and we never touch the sized static icons).
 */
function ensureGenericIconLinkExists() {
  const head = document.head;

  // Prefer a generic rel="icon" link WITHOUT sizes (our "dynamic slot")
  let generic = head.querySelector<HTMLLinkElement>('link[rel="icon"]:not([sizes])');

  if (!generic) {
    generic = document.createElement("link");
    generic.rel = "icon";
    head.appendChild(generic);
  }

  return generic;
}

export const onClientEntry = async () => {
  // Make sure the dynamic slot exists first (so your util can safely update it)
  ensureGenericIconLinkExists();
  setRandomFavicon();

  // Conditionally load polyfills for cross-browser compatibility
  if (!("IntersectionObserver" in window)) {
    await import("intersection-observer");
  }

  if (!("ResizeObserver" in window)) {
    const { default: ResizeObserver } = await import("resize-observer-polyfill");
    (window as any).ResizeObserver = ResizeObserver;
  }

  if ("scrollBehavior" in document.documentElement.style === false) {
    const { polyfill } = await import("smoothscroll-polyfill");
    polyfill();
  }
};

export const onRouteUpdate = () => {
  ensureGenericIconLinkExists();
  setRandomFavicon();
};
